import { useQuery } from "react-query";
import http from "infra/http";
import URL from "core/resources/urls";

function useGetPlanejamentosTalhao(talhaoId: string, safraPeriodoId: string) {
  return useQuery(
    [talhaoId, URL.JUSTIFICATIVA.SALVAR],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.PLANEJAMENTOS_POR_TALHAO(talhaoId), {
        params: {
          safraPeriodoId,
        },
        validateStatus: (status) => status === 200 || status === 404,
      });

      if (data?.status === 404) return [];
      return data;
    },
    {
      enabled: !!talhaoId && !!safraPeriodoId,
    }
  );
}

export default useGetPlanejamentosTalhao;
